import { useContext, useEffect, useState } from 'react';
import { format, utcToZonedTime } from 'date-fns-tz';
import { ProtectedRouteContext } from '../Context';

const translateDateType = (_type) => {
    switch (_type) {
        case 'long':
            return 'PPP';
        case 'long-time':
            return 'PPPp z';
        case 'short-time':
            return 'Pp z';
        case 'short':
        default:
            return 'P';
    }
};

const translateTitle = (_date, _locale, _timezone) => {
    let options = { timeZone: _timezone };
    let _dateType = 'PPPp z';
    if (typeof _date === 'string') {
        return format(utcToZonedTime(new Date(_date), _timezone), _dateType, options);
    } else if (_date instanceof Date) {
        return format(utcToZonedTime(_date, _timezone), _dateType, options);
    } else {
        return format(utcToZonedTime(new Date(_date), _timezone), _dateType, options);
    }
};

/**Renders the date/time string in the user's locale and in the specified format.
 * @param {Object} props Incoming JSX attributes.
 * @param {string} props.date Date/time string in ISO format.
 * @param {"short"|"short-time"|"long"|"long-time"|"relative"} props.type Type of string to render.
 */
export default function DateTimeText(props) {
    const { userSettings } = useContext(ProtectedRouteContext);
    const [date, setDate] = useState(typeof props?.date === 'string' || props?.date instanceof Date ? new Date(props.date) : new Date());
    const [dateType, setDateType] = useState(typeof props?.type === 'string' ? translateDateType(props.type) : 'P');
    const [displayOptions, setDisplayOptions] = useState({});
    const [locale, setLocale] = useState(userSettings?.LanguagePreference ? userSettings.LanguagePreference : 'en-US');
    const [title, setTitle] = useState(translateTitle(props?.date, locale, userSettings.ClientTimeZone));

    useEffect(() => {
        setDisplayOptions((prev) => {
            let _obj =
                !!userSettings.ClientTimeZone && typeof userSettings.ClientTimeZone === 'string'
                    ? {
                          timeZone: userSettings.ClientTimeZone,
                      }
                    : {};

            Object.assign(_obj, prev);

            return _obj;
        });
    }, [userSettings.ClientTimeZone, dateType]);

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLocale(userSettings.LanguagePreference);
        }
    }, [userSettings, userSettings.Retrieved]);

    useEffect(() => {
        setTitle(translateTitle(props?.date, locale, userSettings.ClientTimeZone));
    }, [locale, props.date, userSettings.ClientTimeZone]);

    useEffect(() => {
        let _newDate = !!props?.date ? new Date(props.date) : new Date();
        setDate((prev) => (prev !== _newDate ? _newDate : prev));
    }, [props.date]);

    useEffect(() => {
        if (props.type) {
            setDateType(translateDateType(props.type));
        }
    }, [props.type, date]);

    return (
        <div
            title={title}
            className={typeof props?.className === 'string' ? props.className + ' date-time-text-container' : 'date-time-text-container'}
        >
            {format(utcToZonedTime(date, userSettings.ClientTimeZone), dateType, displayOptions)}
        </div>
    );
}
